
import React from 'react';
import { Navbar } from '../../components/feature/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { VpnSection } from './components/VpnSection';
import { FeaturesSection } from './components/FeaturesSection';
import { FaqSection } from './components/FaqSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <VpnSection />
      <FeaturesSection />
      <ContactSection />
      <AboutSection />
      <FaqSection />
      <Footer />
    </div>
  );
};

export default HomePage;
